import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Document = forwardRef<SVGSVGElement | null, IconFilledProps>(function Document({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.625 3C5.41789 3 5.25 3.16789 5.25 3.375V20.625C5.25 20.8321 5.41789 21 5.625 21H18.375C18.5821 21 18.75 20.8321 18.75 20.625V11.625C18.75 10.1753 17.5747 9 16.125 9H14.625C13.5895 9 12.75 8.16053 12.75 7.125V5.625C12.75 4.17525 11.5747 3 10.125 3H5.625ZM5.625 1.5C4.58947 1.5 3.75 2.33947 3.75 3.375V20.625C3.75 21.6605 4.58947 22.5 5.625 22.5H18.375C19.4105 22.5 20.25 21.6605 20.25 20.625V11.25C20.25 5.86522 15.8848 1.5 10.5 1.5H5.625ZM13.757 3.66785C14.0715 4.25019 14.25 4.91675 14.25 5.625V7.125C14.25 7.33211 14.4179 7.5 14.625 7.5H16.125C16.8332 7.5 17.4998 7.6785 18.0822 7.99296C17.2488 6.05549 15.6945 4.50123 13.757 3.66785ZM7.5 14.75C7.5 14.4739 7.72386 14.25 8 14.25H16C16.2761 14.25 16.5 14.4739 16.5 14.75V15.25C16.5 15.5261 16.2761 15.75 16 15.75H8C7.72386 15.75 7.5 15.5261 7.5 15.25V14.75ZM7.5 17.75C7.5 17.4739 7.72386 17.25 8 17.25H12.25C12.5261 17.25 12.75 17.4739 12.75 17.75V18.25C12.75 18.5261 12.5261 18.75 12.25 18.75H8C7.72386 18.75 7.5 18.5261 7.5 18.25V17.75Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.625 1.5C4.58947 1.5 3.75 2.33947 3.75 3.375V20.625C3.75 21.6605 4.58947 22.5 5.625 22.5H18.375C19.4105 22.5 20.25 21.6605 20.25 20.625V12.75C20.25 10.6789 18.5711 9 16.5 9H14.625C13.5895 9 12.75 8.16053 12.75 7.125V5.25C12.75 3.17893 11.0711 1.5 9 1.5H5.625ZM7.5 14.75C7.5 14.4739 7.72386 14.25 8 14.25H16C16.2761 14.25 16.5 14.4739 16.5 14.75C16.5 14.9167 16.5 15.0833 16.5 15.25C16.5 15.5261 16.2761 15.75 16 15.75H8C7.72386 15.75 7.5 15.5261 7.5 15.25C7.5 15.0833 7.5 14.9167 7.5 14.75ZM8 17.25C7.72386 17.25 7.5 17.4739 7.5 17.75C7.5 17.9167 7.5 18.0833 7.5 18.25C7.5 18.5261 7.72386 18.75 8 18.75H12.25C12.5261 18.75 12.75 18.5261 12.75 18.25C12.75 18.0833 12.75 17.9167 12.75 17.75C12.75 17.4739 12.5261 17.25 12.25 17.25H8Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M13.1067 1.8159C13.9035 2.73648 14.3855 3.93695 14.3855 5.25V7.125C14.3855 7.33211 14.5534 7.5 14.7605 7.5H16.6355C17.9486 7.5 19.149 7.98204 20.0696 8.77881C19.1817 5.37988 16.5056 2.70377 13.1067 1.8159Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'document-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Document;
